import { render, staticRenderFns } from "./AssistentCard.vue?vue&type=template&id=72283b81&scoped=true&"
import script from "./AssistentCard.vue?vue&type=script&lang=js&"
export * from "./AssistentCard.vue?vue&type=script&lang=js&"
import style0 from "./AssistentCard.vue?vue&type=style&index=0&id=72283b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72283b81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
